import handleInviteFriend from "./handleInviteFriend";
import handleUnsubscribe from "./handleUnsubscribe";
import handleFollow from "./handleFollow";
import handleFollowHashtag from "./handleFollowHashtag";
import handleRedirectToCommunity from "./handleRedirectToCommunity";
import handleOtp from "./handleOtp";
import handleUserModeratorRequest from "./handleUserModeratorRequest";
import handleModeratorPendingItems from "./handleModeratorPendingItems";
import handleFlaggedPost from "./handleFlaggedPost";
import handleAcceptPMRole from "./handleAcceptPMRole";
import handleRejectPMRole from "./handleRejectPMRole";
import handleAcceptMRole from "./handleAcceptMRole";
import handleRejectMRole from "./handleRejectMRole";

export function handleEmailAction(searchParams) {
  const action = searchParams.get("action");

  switch (action) {
    case "InviteFriend":
      return handleInviteFriend(searchParams);
    case "unsubscribe":
      return handleUnsubscribe(searchParams);
    case "Follow":
      return handleFollow(searchParams);
    case "followHashtag":
      return handleFollowHashtag(searchParams);
    case "redirectToCommunity":
      return handleRedirectToCommunity(searchParams);
    case "otp":
      return handleOtp(searchParams);
    case "userModeratorRequest":
      return handleUserModeratorRequest(searchParams);
    case "moderatorPendingItems":
      return handleModeratorPendingItems(searchParams);
    case "flaggedPost":
      return handleFlaggedPost(searchParams);
    case "acceptPMRole":
      return handleAcceptPMRole(searchParams);
    case "rejectPMRole":
      return handleRejectPMRole(searchParams);
    case "acceptMRole":
      return handleAcceptMRole(searchParams);
    case "rejectMRole":
      return handleRejectMRole(searchParams);
    default:
      console.warn("Unknown or missing email action:", action);
      return null;
  }
}
